import { ThankYouCardApiClient } from '@fourthwall/services/dist/ThankYouCardApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useThankYouCardSettingsMutation = createMutationHook(
  ThankYouCardApiClient.updateSettings,
  {
    mutationKey: ['thankYouCardSettings'],
  },
)
